var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.visibleItems.length
    ? _c(
        "div",
        {
          ref: "toolbarEl",
          staticClass: "selection-toolbar-wrapper",
          style: _setup.toolbarStyle,
          attrs: { id: _setup.SELECTION_TOOLBAR_ID },
        },
        [
          _vm._l(_setup.visibleItems, function (item, idx) {
            return [
              item.isDivider
                ? _c("div", {
                    key: `toolbar-divider-${idx}`,
                    staticClass: "toolbar-divider",
                  })
                : _c(
                    "button",
                    {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      key: `toolbar-item-${idx}`,
                      staticClass: "toolbar-item",
                      attrs: { content: item.title, title: item.title },
                      on: {
                        click: function ($event) {
                          return _setup.handleItemClick(item)
                        },
                      },
                    },
                    [_c("font-awesome-icon", { attrs: { icon: item.icon } })],
                    1
                  ),
            ]
          }),
          _vm._v(" "),
          _setup.isMultiSelection
            ? [
                _c("div", { staticClass: "toolbar-divider" }),
                _vm._v(" "),
                _vm._l(_setup.ALIGN_MODES, function (mode) {
                  return _c(
                    "button",
                    {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      key: `align-mode-${mode.value}`,
                      staticClass: "toolbar-item",
                      class: { active: _vm.alignType === mode.value },
                      attrs: { content: mode.title, title: mode.title },
                      on: {
                        click: function ($event) {
                          return _setup.emit("align-type-changed", mode.value)
                        },
                      },
                    },
                    [_c("font-awesome-icon", { attrs: { icon: mode.icon } })],
                    1
                  )
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }